// Accepts two shallow objects and returns an array of keys indicating which properties have changed

export default function objectFieldDiff(source, toCheck) {
    const result = [];

    for (let key in source) {
        const sourceValue = source[key];
        const checkValue = toCheck[key];

        if (sourceValue !== checkValue) {
            result.push(key);
        }
    }

    return result;
}
